(function($) {

  $('.menu-toggle').on('click touchstart', function(e) {
    if($('body').hasClass('gemeenten-open')) {
      $('body').removeClass('gemeenten-open');
    }

    $('body').toggleClass('menu-open');
    $('body').toggleClass('no-scroll');
    $('.hamburger-button').toggleClass('is-active');
    if($(this).attr('aria-pressed') === "true"){
      $(this).attr("aria-pressed", false)
    }else{
      $(this).attr("aria-pressed", true)
    }
    e.preventDefault();
  });

  $('.gemeenten-toggle').on('click touchstart', function(e) {
    if($('body').hasClass('menu-open')) {
      $('body').removeClass('menu-open');
    }
    $('body').toggleClass('gemeenten-open');
    $('body').toggleClass('no-scroll');
    if($(this).attr('aria-pressed') === "true"){
      $(this).attr("aria-pressed", false)
    }else{
      $(this).attr("aria-pressed", true)
    }
    e.preventDefault();
  });

})(jQuery);